import React from 'react';
import MetricaBase from './MetricaBase';

const MetricaEstadoCivil = () => {
  return (
    <MetricaBase
      titulo="Distribuição por Estado Civil"
      descricao="Análise da distribuição de colaboradores ativos por estado civil"
      endpoint="estado-civil"
      tipoDownload="estado-civil"
      cor="pink"
    />
  );
};

export default MetricaEstadoCivil;